import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { Laboratorio } from './laboratorios.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LaboratoriosService {
  url: string;
  endpoint = 'laboratorios';

  constructor(private http: HttpClient) {}

  getLaboratorios(): Observable<Laboratorio[]> {
    return this.http.get<Laboratorio[]>(`${this.url}/${this.endpoint}/`);
  }

  addLaboratorios(laboratorios: Laboratorio[]): Observable<Laboratorio[]> {
    return this.http.post<Laboratorio[]>(`${this.url}/${this.endpoint}/`, {
      laboratorios
    });
  }

  deleteLaboratorio(laboratorio: Laboratorio): Observable<Laboratorio> {
    return this.http.delete<Laboratorio>(
      `${environment.apiUrl}/${this.endpoint}/${laboratorio.id}/`
    );
  }
}
